export default "__VITE_ASSET__27Y4zFjW__"